import { useEffect, useRef } from 'react';
import SlimSelect from 'slim-select';
import '../../../../node_modules/slim-select/dist/slimselect.css';
import { Typography } from '../Typography';

export interface SelectOption {
    value: string;
    label: string;
}

interface MultipleSelectWithSearchProps {
    label: string;
    options: SelectOption[];
    value?: string[];
    onChange?: (selectedValues: string[]) => void;
}

export default function MultipleSelectWithSearch({ label, options, value = [], onChange }: MultipleSelectWithSearchProps) {
    const selectRef = useRef<HTMLSelectElement | null>(null);
    const slimRef = useRef<SlimSelect | null>(null);
    const portalRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!selectRef.current || !portalRef.current) return;

        const portalEl = portalRef.current;
        portalEl.style.position = portalEl.style.position || 'relative';
        portalEl.style.zIndex = portalEl.style.zIndex || '9999';

        const instance = new SlimSelect({
            select: selectRef.current,
            settings: {
                placeholderText: '',
                contentLocation: portalEl,
            },
            events: {
                afterChange: (newVals: Array<{ value: string; text: string }>) => {
                    const selectedValues = newVals.map((v) => v.value);
                    onChange?.(selectedValues);
                },
            },
        });

        slimRef.current = instance;

        if (value.length > 0) {
            instance.setSelected(value);
        }

        return () => {
            instance.destroy();
            slimRef.current = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!slimRef.current) return;
        slimRef.current.setSelected(value);
    }, [value]);

    return (
        <>
            <Typography color="muted" fontSize="12">
                {label}
            </Typography>
            <select ref={selectRef} multiple>
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
            <div className="slim-select-options-container" ref={portalRef} />
        </>
    );
}
